import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'commaSeparatedToArray',
  standalone: true
})
export class CommaSeparatedToArrayPipe implements PipeTransform {
  transform(value: string | null | undefined): string[] {
    if (!value) {
      return new Array('');
    }
    return value.split(',');
  }
}
